<template>
    <div class="history-chart">
        <highcharts :options="chartOptions"></highcharts>
    </div>
</template>

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'
    import Colors from '@/providers/GaugeColors'

    export default Vue.extend({
        props: {
            dates: Array,
            vals: Array,
            thresholds: Array,
            limits: Array,
            ticks: Number,
            higherIsBetter: Number
        },
        data: function () {

            var self = this;

            // calculate plot bands based on different options
            var yMin = +this.limits[0];
            var yMax = +this.limits[1];
            var plotBands = [];
            var bandColors = Colors.GAUGE_DISABLED_COLORS; // see GaugeColors.js
            for (var i = 0; i <= this.thresholds.length; i++) {
                var band = {};

                if (i == 0) {
                    band.from = yMin;
                    band.to = this.thresholds[0];
                    band.color = (this.higherIsBetter ? bandColors[this.thresholds.length] : bandColors[0]);
                } else if (i == this.thresholds.length) {
                    band.from = this.thresholds[i - 1];
                    band.to = yMax;
                    band.color = (this.higherIsBetter ? bandColors[0] : bandColors[this.thresholds.length]);
                } else {
                    band.from = this.thresholds[i - 1];
                    band.to = this.thresholds[i];
                    band.color = (this.higherIsBetter ? bandColors[this.thresholds.length - i] : bandColors[i]);
                }
                plotBands.push(band);
            }

            return {
                chartOptions: {
                    chart: {
                        type: 'line',
                        height: 150,
                        width: 300,
                    },
                    title: {
                        text: self.countLabel,
                        align: 'right',
                        verticalAlign: 'top',
                        y: 4,
                        style: {
                            color: '#666',
                            fontSize: '11px',
                            fontWeight: 'bold'
                        }
                    },
                    credits: {enabled: false},
                    tooltip: {enabled: false},
                    legend: {enabled: false},

                    xAxis: {
                        // type: 'datetime',
                        tickInterval: 1
                    },
                    yAxis: {
                        title: {text: ''},
                        plotBands: plotBands,
                        min: yMin,
                        max: yMax,
                        // showFirstLabel: false,
                        // showLastLabel: false,
                    },

                    series: [
                        {
                            pointWidth: 8,
                            data: _.map(self.vals, function (val, index) {
                                return [+self.dates[index], +val];
                            })
                        },
                    ]

                },
            }
        }
    })
</script>

<style lang="scss">
    .history-chart {
        width: 300px;
        overflow: hidden;
        display: inline-block;
    }
</style>
